import TitleBlock from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import CardModal from '@anm/components/modals/CardModal';
import isMobile from '@anm/helpers/is/isMobile';
import { FC } from 'react';

import DeleteFolderRow from './DeleteFolderRow';
import RowWithCheckbox from './RowWithCheckbox';
import { AlertWrapper, ButtonsContainer, ContentWrapper, ListWrapper } from './Wrapper';
import { useDeleteStreamFromFolderHandlers, useDestinationHandlers } from './hooks';
import { DeleteScheduledStreamModalProps } from './types';

type ModalProps = Omit<DeleteScheduledStreamModalProps, 'canDeleteFile'> & {
  isLive: boolean;
  hasUpload: boolean;
  canDeleteFile: boolean;
  isDeleteFromWave: boolean;
  openProjects(): void;
};

export const ModalContent: FC<ModalProps> = ({
  list,
  isLive,
  hasUpload,
  isPending,
  onDelete,
  onModalClose,
  canDeleteFile,
  isPastStream,
  isDeleteFromWave,
  showFolderCheckbox,
  openProjects,
  ...titleProps
}) => {
  const [isChecked, handleChange] = useDeleteStreamFromFolderHandlers();
  const [handleAddDeleteId, handleDeleteDestinations, checkedDestinationIds] = useDestinationHandlers({
    list,
    isPastStream,
    canDeleteFile: isChecked,
    onModalClose,
    onDelete
  });

  const isAssetUsedInMultipleProjects = hasUpload && isDeleteFromWave && !canDeleteFile;

  return (
    <ContentWrapper>
      <TitleBlock level={3} {...titleProps} />
      {list.length > 0 && !isDeleteFromWave && (
        <ListWrapper>
          {list.map(item => (
            <RowWithCheckbox
              key={item.id}
              isChecked={checkedDestinationIds.includes(item.id)}
              {...item}
              onChange={handleAddDeleteId}
            />
          ))}
        </ListWrapper>
      )}
      {showFolderCheckbox && !isDeleteFromWave && (
        <DeleteFolderRow {...{ isChecked }} isDisabled={showFolderCheckbox && !canDeleteFile} onChange={handleChange} />
      )}
      {isAssetUsedInMultipleProjects && (
        <AlertWrapper variant="danger" position="left">
          <span>
            We can’t delete this recording file, because it is used in <p onClick={openProjects}>these projects</p>.
            Please, remove it from the projects first.
          </span>
        </AlertWrapper>
      )}
      <ButtonsContainer>
        <Button size="large" variant="silver-border" onClick={onModalClose}>
          Cancel
        </Button>
        <ButtonLoader
          size="large"
          variant="red"
          isPending={isPending}
          disabled={isAssetUsedInMultipleProjects}
          onClick={handleDeleteDestinations}
        >
          Yes, delete
        </ButtonLoader>
      </ButtonsContainer>
    </ContentWrapper>
  );
};

const DeleteModal: FC<ModalProps> = props => (
  <CardModal onModalClose={props.onModalClose} isCloseButtonInsideModal={isMobile()}>
    <ModalContent {...props} />
  </CardModal>
);

export default DeleteModal;
